<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"

        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <!--      :otherParams="{'isDealerId':navSwitch}"-->
      <template v-slot:[toolbarConfig.templatelSlots]>
        <div class="top_btns_box"
             style="display: flex"
        >
          <div class="status_box">
<!--            <span class="status_item active"  @click="showRecord(0)">返回</span>-->
<!--            <span class="status_item" :class="navSwitch?'active':''" @click="changeNav(1)">已分配成员</span>-->
          </div>
        </div>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <formModal
        title="已分配的非企微客户"
        centered
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
        :closable="true"
        @cancelled="closeDetailPop"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @closeParent="closeDetailPop"
          @openParent="openDetailPop"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>
  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/client/clientInheritRecord/detail";

//弹出层组件
import {mapMutations, mapState} from "vuex";
import {dataApi} from "@/services/client/inherit.js";
// import user from "@/services/user";

const fac = XGrid.factory;

//列表接口
// const url = this.navSwitch ? api.client.SCRM + '/custAssignRecord' : api.client.INHERIT + '/getQuitUserPageList';
const url = api.client.SCRM + '/custAssignRecord';

//主键
const rowId = "userId";

//列
const columns = [
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("userName", "已分配成员", 'auto', 'center'),
  fac.makeColumn("dealerName", "经销商", 'auto', "center"),
  fac.makeColumn("regionName", "经理部", 'auto', "center"),
  fac.makeColumn("custNum", "已分配客户数", 'auto', "center"),
  fac.makeColumn("quitDate", "离职时间", 'auto', "center"),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "userName"},
  {
    field: "regionName",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    type: "select",
    options: [],
  },
  {
    field: 'createDate',
    title: "离职时间",
    type: 'dateRange',
  }
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  this.strainOptions = await loadBaseCodeData('CD200007')
  this.wantLevelOptions = await loadBaseCodeData('CD200002')

  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  // let commCodeData = await dataApi.getCommCode();
  // let DeptUsers = await dataApi.getDeptUsers();
  // if(DeptUsers.code!==200){
  // }
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    regionName: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);

  console.log(179,this.dealerOptions);

  this.loadSearchOption({
    dealerName: this.dealerOptions,
  })
  this.strainOptions = this.strainOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainName: this.strainOptions,
  })

  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    wantLevelName: this.wantLevelOptions,
  })
}


export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   // delRow: 'DELETE',
  //   // importMethod:'IMPORT',
  //   // exportMethod:'EXPORT',
  // },
  components: {
    detailForm,
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  watch: {
    $route: {
      handler: function (newValue, oldValue) {
        if (oldValue && newValue.path === '/clue/clueManage') {
          this.startDate = this.$store.state.setting.startTime || null
          this.endDate = this.$store.state.setting.endTime || null
          this.isTodayFollow = this.$store.state.setting.isTodayFollow || null
          this.$nextTick(() => {
            this.refresh()
          })
        } else {
          this.setStartTime(null)
          this.setEndTime(null)
          this.setIsTodayFollow(0)
        }
      },
      immediate: true,
    }
  },
  data() {
    return {
      navSwitch: 0,
      showAssignPop: false,
      regionOptions: [],
      dealerOptions: [],
      assignIdArr: [], //将选中的离职成员的客户（多选）都分配给分配人（单选）
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      strainOptions: [],
      wantLevelOptions: [],
      startDate: this.$store.state.setting.startTime || null,
      endDate: this.$store.state.setting.endTime || null,
      isTodayFollow: this.$store.state.setting.isTodayFollow || null,
      isNotFollow: this.$route.query.isNotFollow,
      fromIndexParam: this.$route.query.fromIndexParam,
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations('setting', ['setStartTime', 'setEndTime', 'setIsTodayFollow']),
    loadBaseData,
    showRecord(type) {
      switch (type) {
        case 0:
          this.$router.push({
            path: '/client/clientInherit'
          })
          break;
        case 1:
          this.$router.push({
            path: '/client/clientInheritRecord'
          })
          break;
      }
    },
    // changeNav(status) { //切换nav状态
    //   this.navSwitch = status;
    //   const vm = this;
    //   this.$nextTick(() => {
    //     vm.refresh()
    //   })
    // },
    // 弹出分配人列表 选择分配人进行分配
    showAssignPopFunc(row) {
      //判断操作 是批量还是单条数据
      if (!row.userId) { //批量
        let rowArr = this.getRows();
        if (!rowArr.length) {
          this.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          this.assignIdArr = rowResult.map(item => item.userId);
          this.showAssignPop = true;
        }
      } else {  //单条数据
        this.assignIdArr.push(row.userId);
        this.showAssignPop = true;
      }
    },
    // 关闭弹窗
    closePop() {
      this.showAssignPop = false; //分配人列表
      this.refresh();
    },
    //关闭详情
    closeDetailPop() {
      this.editModalVisible = false;
    },
    //打开详情
    openDetailPop() {
      this.editModalVisible = true;
    },
    async createAccount() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return;
      }
      console.log(rows)
      const userId = rows[0].userId
      console.log(userId)
      await dataApi.accountNumber(userId).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg)
        }
        console.log(res)
        this.refresh();
      }).catch(e => {
        console.log(e);
      })
    },
    merchants() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      console.log(rows)
      this.userIdList = rows.map((i) => {
        return i.userId;
      }).join(',')
      console.log(this.userIdList)
      this.chooseOpenPop('merchantsAuthorization', 1)
    },
    closeLog() {
      this.logModalVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>

.top_btns_box {
  padding-top: 20px;
}

.status_box {
  margin: 0 30px 12px 0;
  position: relative;
  top: -6px;

  .status_item {
    width: 120px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 38px;
    display: inline-block;
    background-color: #E9F5FC;
    cursor: pointer;

    &.active {
      background-color: #D90B18;
      color: #fff;
    }
  }
}

</style>
